type Props = {
  color: string;
};

export default function RightArrowIcon(props: Props) {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.84644 14.7688L7.76953 7.8457L0.84644 0.922612"
        stroke={props.color}
        strokeWidth="2"
      />
    </svg>
  );
}
